<lib-chart-scatter disableLegend [chartConf]="conf"/>